import React, { memo, useContext } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../index'
import { LanguageContext } from '../../../context/LanguageContext'

const ModalActions = ({
    cancelModalHandler,
    saveClickHandler,
    submitBtn,
    cancelBtn,
    disabledBtn,
    color,
    size,
}) => {
    const { rtl } = useContext(LanguageContext)

    return (
        <>
            <Button
                data-testid={'modal-cancel-action'}
                size={size}
                className={rtl ? 'ml-7' : 'mr-7'}
                onClick={cancelModalHandler}
            >
                {cancelBtn}
            </Button>
            <Button
                data-testid={'modal-save-action'}
                color={color}
                size={size}
                disabled={disabledBtn}
                onClick={saveClickHandler}
            >
                {submitBtn}
            </Button>
        </>
    )
}

ModalActions.propTypes = {
    cancelModalHandler: PropTypes.func,
    saveClickHandler: PropTypes.func,
    submitBtn: PropTypes.string,
    cancelBtn: PropTypes.string,
    disabledBtn: PropTypes.bool,
    color: PropTypes.string,
    size: PropTypes.string,
}

export default memo(ModalActions)
